export default {
  h1: {
    fontWeight: 500,
    fontSize: 35,
    fontFamily: "'Saira Semi Condensed', sans-serif",
    color: "#000",
    "@media(max-width:767px)": {
      fontSize: "20px",
    },
  },

  h2: {
    fontWeight: 500,
    fontSize: 30,
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
  h3: {
    fontWeight: 500,
    fontSize: 25,
    fontFamily: "'Saira Semi Condensed', sans-serif",
    color: "#fff",
  },
  h4: {
    fontWeight: 500,
    fontSize: 20,
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
  h5: {
    fontWeight: 500,
    fontSize: 18,
    color:'black',
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
  h6: {
    fontWeight: 500,
    fontSize: 16,
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
  overline: {
    fontWeight: 500,
  },
  button: {
    textTransform: "capitalize",
    borderRadius: 27,
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
  body1: {
    fontSize: 16,
    color: "#fff",
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
  body2: {
    fontSize: 14,
    fontWeight: "300",
    color: "#fff",
    lineHeight: "21px",
    fontFamily: "'Saira Semi Condensed', sans-serif",
  },
};
